export default __webpack_public_path__ + "static/media/calendarIcon.d54ba19e.svg";